/**
 * User: Nikolai Gorte * Date: 17.11.23 * Time: 16:09
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';

export const ActiveFilterBar = ({
  onFilterRemove,
  onFilterReset,
  activeFilters,
  className
}) => {

  return (
    <div className={`active-filter-bar ${className}`}>
      {
        activeFilters.map(f => (
          <Button
            key={f.type + f.value}
            variant="outline-primary"
            onClick={() => onFilterRemove(f)}
          >
            <div className="d-flex flex-row align-items-center">
              <span className="mx-3">{f.altLabel || f.label}</span>
              <i className="icon icon-fliwas-x" aria-hidden="true"/>
            </div>
          </Button>
        ))
      }
      {activeFilters.length > 1 && (
        <Button
          variant="outline-danger"
          className="btn-reset"
          onClick={onFilterReset}
        >
          <div className="d-flex flex-row align-items-center">
            <span className="mx-3">Alle Filter löschen</span>
            <i className="fa fa-trash" aria-hidden="true"/>
          </div>
        </Button>
      )}
    </div>
  );
};

ActiveFilterBar.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
    label: PropTypes.string.isRequired,
    altLabel: PropTypes.string
  })),
  onFilterRemove: PropTypes.func,
  onFilterReset: PropTypes.func,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/ActiveFilterBar.jsx